import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';

export class RecordSummaryRelationDto {
  key!: string;
  subject!: AppSubjectEnum;
  total!: number;
  byStatus!: Record<string, number>;
}
